export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "category": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Catégorie"])},
        "vendor": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vendeur"])},
        "model": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Modèle"])},
        "price": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Prix"])},
        "reference_id": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["N° série"])}
      },
      "en": {
        "category": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Category"])},
        "vendor": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vendor"])},
        "model": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Model"])},
        "price": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Price"])},
        "reference_id": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Serial number"])}
      }
    }
  })
}
